import { render, staticRenderFns } from "./certMgr.vue?vue&type=template&id=53a27db6&"
import script from "./certMgr.vue?vue&type=script&lang=js&"
export * from "./certMgr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports